module.exports = __webpack_public_path__ + "img/app.d9e51cce.png";